"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDebug = void 0;
const react_1 = __importStar(require("react"));
const DebugWidget = react_1.default.lazy(() => Promise.resolve().then(() => __importStar(require("./debug-widget"))));
const DebugContext = (0, react_1.createContext)({});
const DEBUG_LOCAL_KEY = 'site-debug-status';
const DEBUG_INITIAL_STATE = {
    showBlockNames: false,
    showTemplateNames: false,
    showCurrentPublishState: false,
};
const debugShowReducer = (state, action) => {
    const update = Object.fromEntries(Object.entries({
        ...state,
        ...action,
        // Debug context might have old options we should remove
    }).filter(([key]) => DEBUG_INITIAL_STATE[key] !== undefined));
    try {
        localStorage.setItem(DEBUG_LOCAL_KEY, JSON.stringify(update));
        // eslint-disable-next-line no-empty
    }
    catch (e) {
        // ignore non-working localstorage
    }
    // This could probably be typed better
    return update;
};
const DebugProvider = ({ children, id }) => {
    const shouldRenderWidget = (process.env.NODE_ENV === 'development' || process.env.GATSBY_ATL_DRAFTS_MODE === "true");
    const [show, setShow] = (0, react_1.useReducer)(debugShowReducer, {}, () => DEBUG_INITIAL_STATE);
    const update = (key) => {
        setShow({ [key]: !show[key] });
    };
    (0, react_1.useEffect)(() => {
        /*
        * Update from localStorage once window is defined
        * */
        let localDebug;
        try {
            if (shouldRenderWidget) {
                localDebug = localStorage.getItem(DEBUG_LOCAL_KEY);
                if (localDebug) {
                    const parsed = JSON.parse(localDebug);
                    if (parsed && typeof parsed === 'object' && Object.keys(parsed).length > 0) {
                        setShow(parsed);
                    }
                }
            }
            // eslint-disable-next-line no-empty
        }
        catch (e) {
            // ignore non-working localstorage
        }
    }, [shouldRenderWidget]);
    return (react_1.default.createElement(DebugContext.Provider, { value: show },
        shouldRenderWidget && (react_1.default.createElement(react_1.default.Suspense, { fallback: null },
            react_1.default.createElement(DebugWidget, { update: update, id: id }))),
        children));
};
exports.default = DebugProvider;
const useDebug = () => {
    const ctx = (0, react_1.useContext)(DebugContext);
    if (!ctx) {
        throw new Error('useDebug is missing parent DebugProvider.');
    }
    return ctx;
};
exports.useDebug = useDebug;
//# sourceMappingURL=debug-provider.js.map